export const SENTRY_TOKEN =
  "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";

export const DSN_WEB =
  "https://e3f65c21266d62db79be2487d88c964f@o4506575569354752.ingest.us.sentry.io/4511585482506240";

export const DSN_ANDROID =
  "https://96bb9f5d3641a71592178705fc3cd03e@o4506575569354752.ingest.us.sentry.io/4511585485914112";
